import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Migas de pan" className="flex items-center flex-wrap gap-1 text-xs text-muted-foreground mb-6" data-testid="breadcrumbs">
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1">
          {i > 0 && <ChevronRight size={12} />}
          {it.to ? <Link to={it.to} className="hover:text-foreground transition-colors">{it.label}</Link>
                 : <span className="text-foreground">{it.label}</span>}
        </span>
      ))}
    </nav>
  );
}

export function Overline({ children }) {
  return <div className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3">{children}</div>;
}

export function PageHeader({ overline, title, subtitle, children }) {
  return (
    <div className="border-b border-border bg-card">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        {overline && <Overline>{overline}</Overline>}
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
